// views
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

import Brand from '../components/splash/Brand';
import HelpFooter from '../components/HelpFooter';
import NuFetch from '../utils/NuFetch';

// view utils
import { metal_conversion } from '../utils/utils';

import BtnThumbs from '../components/BtnThumbs';
import CryptoPill from '../components/CryptoPill';
import CertDetails from '../components/CertDetails';

export default function CertificateEdit ( )
{
  const { cert } = useParams();
  // const [ cookies, setCookies, removeCookies ] = useCookies(['certop']);

  const [ certData, setCertData ] = useState( null );
  const [ notify, setNotify ]     = useState({  });
  const [ loading, setLoading ]   = useState( true );
  const [ todoMsg, setTodoMsg ]   = useState( '...' );
  const [ currentCert, set_current_cert ] = useState( '' );

  const [ _cert, set_cert ]       = useState( cert );
  const [ btnActive, set_btn_active ] = useState( false );

  useEffect(() => {
    set_btn_active( false );

    setTodoMsg( 'modifica stato certificato' );

    if ( _cert != null ) {
      let trimCert = _cert.substring( 0, 8 );

      NuFetch({
        op: 'get_certificate',
        microID: trimCert
      }, 'cert' ).then( re => {
        setCertData( re[0] );
        set_btn_active( true );

      }).catch( er => {
        set_btn_active( false );
        setNotify( er );
      });

    } else {
      set_btn_active( false );
      setTodoMsg( 'token nullo' );
      setNotify({ type:'error', msg:'nessun token' });
    }
  }, [_cert, loading ]);

  return (
    <div className='full'>
      <Brand
        variant = "lg"
        align   = "center" />

      <div className = 'contents--' >
        <h3> certificato corrente : { _cert } </h3>

        <input
          className   = 'form-control gg-input'
          title       = 'token'
          placeholder = 'certificato'
          onChange    = { val => set_current_cert( val.target.value ) }
          disabled    = { false } />

        <div className='button-group'>
          < BtnThumbs
            type      = 'refresh'
            text      = 'carica nuovo certificato'
            _action   = { () => token_change() }
          />
        </div>

        { certData &&
          <>
          <div className='data-group'>
            < CryptoPill
              data = { certData }
            />

            < CertDetails
              certificate = { certData }
            />
          </div>

          { certData.state != 0 &&
            <h1 className='danger'> ATTENZIONE CERTIFICATO GIA ATTIVO ! </h1>
          }

          <div className='button-group'>
            { btnActive &&
              < BtnThumbs
                type         = 'up'
                text         = 'attiva certificato'
                disabled     = { certData.state != 0 }
                _action      = { () => activate( certData.microID ) }
              />
            }
          </div>
          </>
        }



      </div>

      <HelpFooter
        href="mailto:support@gekogold.com"
        target="_self" />
    </div>
  );

  // 2026 TESTING FUNCS :::::

  function activate ( microID )
  {
    setLoading( true );
    NuFetch({
      op: 'activate_certificate', microID
    }, 'cert' ).then( re => {
      setNotify({ type:'success', msg:'certificato attivato' });
      setLoading( false );
    }).catch( er => {
      setNotify( er );
    });
  }

  function token_change (  )
  {
    let token = currentCert;
    let shortToken = token.substring( token.length - 8 );
    if ( shortToken.length === 8 ) {
      console.log( shortToken );
      set_cert( shortToken );
    }
  }
}
